<template>
  <section
    v-if="text"
    class="ex-about"
  >
    <h3>{{ t('exclusiveUnits.commission.aboutHeading') }}</h3>
    <p>{{ text }}</p>
  </section>
</template>

<script setup lang="ts">
// Catalogue why-exclusive text, rendered as plain text (never v-html).
const { text = null } = defineProps<{
  text?: string | null;
}>();

const { t } = useI18n();
</script>

<style scoped lang="scss">
.ex-about {
  color: #0d0f15;

  h3 {
    font-size: 15px;
    font-weight: 700;
    margin: 0 0 6px;
  }

  p {
    font-size: 14px;
    line-height: 1.55;
    color: rgba(13, 15, 21, 0.8);
    margin: 0;
    white-space: pre-line;
  }
}
</style>
